module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_section_heat.05b39.png";